module.exports = __webpack_public_path__ + "static/variant-offer-modal-desktop-bf79988d89b09f06ecfb10833a69cd9e.png";